// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"n_bh ml-3","matrix-table--pad4":"n_bj ml-5","matrix-table__title":"n_bk","matrix-table__true":"n_bl","matrix-table__false":"n_bm"};